<template>
  <div class="labels" ref="labelBox">
    <span v-for="text in list" :key="text" @click="onSelect(text)" class="label van-ellipsis">{{ text }}</span>
  </div>
</template>

<script >
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    labelsHeight: ''
  },
  watch: {
    list: {
      handler: function (newVal) {
        this.$nextTick(() => {
          this.$emit('update:labelsHeight', this.$el.offsetHeight);
        });
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    onSelect(val) {
      this.$emit('onSelect', val);
    }
  }
};
</script>

<style lang="less" scoped>
.labels {
  padding: 0 16px;
}
.label {
  color: #595959;
  display: inline-block;
  max-width: 100%;
  height: 32px;
  line-height: 32px;
  padding: 0 16px;
  background: #f5f5f5;
  border-radius: 16px;
  margin-bottom: 8px;
  margin-right: 8px;
  font-size: 14px;
  vertical-align: bottom;
}
</style>
